/* DGA nieuwe huisstijl: footer op de WS2.0-paginalaag.
   1. 'Aanbod' en 'Automaat plaatsen' als uitklapmenu met logische kopjes
      - de bestaande links (uit de Shopify-menu's) worden alleen gegroepeerd, niet aangepast
      - klik op het kopje of het pijltje klapt open en dicht; per kolom staat er steeds een open
      - herkent de links op Nederlandse tekst; matcht minder dan de helft (bijv. /de), dan blijft de lijst zoals hij was
      - de pijltjes staan per kolom recht onder elkaar, met een beetje afstand achter het langste kopje
        (de breedte van het langste kopje wordt gemeten en als --pg-ft-w aan de kolom meegegeven)
   2. 'Plan bezichtiging' als knop bij 'Offerte aanvragen' (zonder icoon)
   3. Contactgegevens verhuizen naar de kolom 'Onze vestigingen'; vlaggetjes rond
      (herkent het kopje in het Nederlands 'Contact...' en in het Duits 'Kontakt...')
   4. 'Route plannen' vervalt: het adres zelf (met het locatie-icoon ervoor) linkt naar de routeplanner
   5. Label 'Showroom' per vestiging linkt naar de bezichtigingspagina van die showroom
      (NL: /pages/boek-een-bezichtiging; DE: de Duitse versie van die pagina, met Heusenstamm voorop)
      Op de NL-footer is het label bij Duitsland geen link (geen Duitse showroom op de NL-pagina)
   6. Duitse footer (/de) in dezelfde opmaak als de Nederlandse:
      - de Duitse showroom (Deutschland) staat bovenaan, Nederland eronder
      - het lange kopje 'Kauf von Verkaufsautomaten in Ihrem Gebiet' wordt 'In Ihrem Gebiet', zodat alle
        kolomkoppen op één regel staan, net als in de Nederlandse footer
   Wordt geladen op alle WS2.0-templates (snippets/meta-tags.liquid). */
(function(){
  var SHOWROOM_PATH='/pages/boek-een-bezichtiging';
  /* De Duitse boekingspagina heeft een eigen handle (21-10-2026) */
  var SHOWROOM_PATH_DE='/de/pages/buchen-sie-eine-besichtigung';
  /* Korte kolomkoppen (alleen weergave; de links eronder blijven gelijk) */
  var SHORT_HEAD={'Kauf von Verkaufsautomaten in Ihrem Gebiet':'In Ihrem Gebiet'};
  /* [kopje, patroon, vangnet]; volgorde = volgorde in de footer */
  var CFG={
    'Aanbod':[
      ['Populaire automaten',/^(alle verkoopautomaten|snackautomaten|frisdrankautomaten|koffieautomaten|smart fridge|voedingsautomaten|warenautomaten|self-service machine|coca cola)/i],
      ['Boerderij & vers',/^(boerderij|kaas|melk|eier|aardappel|appel|aardbeien|bloemen|worst|ijs|bier)/i],
      ['Merken',/^(vendo|necta|sielaff)/i],
      ['Speciale automaten',null,true],
      ['Kopen & leasen',/(kopen|leasen|plaatsen)$/i]
    ],
    'Automaat plaatsen':[
      ['Werk & bedrijf',/^(callcenters|logistieke|productiebedrijven|kantoren)/i],
      ['Onderwijs & wonen',/^(middelbare|hogescholen|vakscholen|studentenpanden|appartementen)/i],
      ['Sport & vrije tijd',/^(sportverenigingen|zwembaden|sportscholen)/i],
      ['Openbaar & zorg',null,true]
    ],
    /* Duitse footer (/de): dezelfde opbouw met Duitse kopjes */
    'Angebot':[
      ['Beliebte Automaten',/^(alle verkaufsautomaten|verkaufsautomaten$|snackautomaten|getränkeautomaten$|gebrauchte getränkeautomaten|kaffeeautomaten|smart fridge|lebensmittelautomaten|warenautomaten|selbstbedienungsautomaten|coca cola|dosenautomaten)/i],
      ['Hofladen & Frische',/^(hofladen|käse|milch|eier|kartoffel|apfel|erdbeer|honig|wurst|eis|bier|wein|fleisch)/i],
      ['Marken',/^(vendo|necta|sielaff)/i],
      ['Spezialautomaten',null,true],
      ['Kaufen & Leasen',/((kaufen|aufstellen|nach maß)$|^(leasing|überholte|neue verkaufsautomaten|automatenshop))/i]
    ],
    'Kauf von Verkaufsautomaten in Ihrem Gebiet':[
      ['Nord & West',/(hamburg|bremen|hannover|köln|düsseldorf|dortmund|essen|duisburg|bochum|münster|bielefeld|bonn)/i],
      ['Süd',/(münchen|stuttgart|nürnberg|augsburg|karlsruhe|mannheim|freiburg)/i],
      ['Mitte & Ost',/(berlin|frankfurt|leipzig|dresden|wiesbaden|mainz|kassel|erfurt)/i],
      ['Österreich & weitere',null,true]
    ]
  };
  var n=0;
  var isDe=/^\/de(\/|$)/.test(location.pathname);
  function svgIcon(){
    var ns='http://www.w3.org/2000/svg',s=document.createElementNS(ns,'svg'),p=document.createElementNS(ns,'path');
    s.setAttribute('viewBox','0 0 10 6');s.setAttribute('class','pg-fhead__ico');s.setAttribute('aria-hidden','true');s.setAttribute('focusable','false');
    p.setAttribute('d','M1 1l4 4 4-4');p.setAttribute('fill','none');p.setAttribute('stroke','currentColor');p.setAttribute('stroke-width','1.5');p.setAttribute('stroke-linecap','round');p.setAttribute('stroke-linejoin','round');
    s.appendChild(p);return s;
  }
  /* Pijltjes recht onder elkaar: elk kopje krijgt de breedte van het langste kopje in die kolom */
  function alignHeads(wrap){
    var w=0;
    [].forEach.call(wrap.querySelectorAll('.pg-fhead__tx'),function(s){w=Math.max(w,s.getBoundingClientRect().width);});
    if(w>0)wrap.style.setProperty('--pg-ft-w',Math.ceil(w)+'px');
  }
  var wraps=[];
  function build(details,cfg){
    var ul=details.querySelector('ul');
    if(!ul||details.querySelector('.pg-fgroups'))return;
    var lis=[].slice.call(ul.children),buckets=cfg.map(function(){return [];}),matched=0,catchAll=-1;
    cfg.forEach(function(g,i){if(g[2])catchAll=i;});
    lis.forEach(function(li){
      var t=(li.textContent||'').trim(),idx=-1;
      for(var i=0;i<cfg.length;i++){if(!cfg[i][2]&&cfg[i][1].test(t)){idx=i;break;}}
      if(idx<0)idx=catchAll;else matched++;
      buckets[idx].push(li);
    });
    if(matched<lis.length*0.5)return;
    var wrap=document.createElement('div');wrap.className='pg-fgroups';
    cfg.forEach(function(g,i){
      if(!buckets[i].length)return;
      var id='pg-fgroup-'+(++n);
      var grp=document.createElement('div');grp.className='pg-fgroup';
      var btn=document.createElement('button');btn.type='button';btn.className='pg-fhead';btn.setAttribute('aria-expanded','false');btn.setAttribute('aria-controls',id);
      var t=document.createElement('span');t.className='pg-fhead__t';
      var tx=document.createElement('span');tx.className='pg-fhead__tx';tx.textContent=g[0];t.appendChild(tx);
      btn.appendChild(t);btn.appendChild(svgIcon());
      var body=document.createElement('div');body.className='pg-fbody';body.id=id;
      var inner=document.createElement('div');inner.className='pg-fbody__in';
      var list=ul.cloneNode(false);buckets[i].forEach(function(li){list.appendChild(li);});
      inner.appendChild(list);body.appendChild(inner);
      grp.appendChild(btn);grp.appendChild(body);wrap.appendChild(grp);
      btn.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        var open=grp.classList.contains('is-open');
        [].forEach.call(wrap.querySelectorAll('.pg-fgroup.is-open'),function(o){o.classList.remove('is-open');o.querySelector('.pg-fhead').setAttribute('aria-expanded','false');});
        if(!open){grp.classList.add('is-open');btn.setAttribute('aria-expanded','true');}
        /* Mobiel: het thema geeft het uitgeklapte footer-blok soms een vaste hoogte; die laten meegroeien */
        var c=details.querySelector('summary')&&details.querySelector('summary').nextElementSibling;
        if(c&&c.style&&c.style.height){c.style.height='auto';}
      });
    });
    ul.parentNode.replaceChild(wrap,ul);
    details.classList.add('pg-fcol');
    wraps.push(wrap);alignHeads(wrap);
    /* Op mobiel staat de kolom eerst dicht: bij openen opnieuw meten */
    details.addEventListener('toggle',function(){alignHeads(wrap);});
  }
  /* Kolomkop korter weergeven (zelfde opmaak als de Nederlandse koppen op één regel).
     Zoekt de tekst in de hele kop (ook in een span binnen de kop) en past alleen die tekst aan. */
  function shortHead(details,head){
    var s=SHORT_HEAD[head];if(!s)return;
    var sum=details.querySelector('summary');if(!sum)return;
    var w=document.createTreeWalker(sum,NodeFilter.SHOW_TEXT),nd;
    while((nd=w.nextNode())){if(nd.data.trim()===head){nd.data=nd.data.replace(head,s);break;}}
    sum.setAttribute('title',head);
  }
  function locations(root){
    var loc=root.querySelector('.dga-loc');if(!loc||loc.dataset.pgDone)return;loc.dataset.pgDone='1';
    var brand=root.querySelector('.footer-block__brand-info');
    /* Contactgegevens naar de vestigingen-kolom, direct onder de kop */
    if(brand){
      var heads=[].slice.call(brand.querySelectorAll('.footer-block__heading'));
      var ch=heads.filter(function(h){return /contact|kontakt/i.test(h.textContent||'');})[0];
      var list=ch&&ch.nextElementSibling&&ch.nextElementSibling.tagName==='UL'?ch.nextElementSibling:null;
      var cards=loc.querySelector('.dga-loc__cards');
      if(list&&cards){list.classList.add('pg-loc-contact');loc.insertBefore(list,cards);ch.parentNode.removeChild(ch);}
    }
    /* 'Plan bezichtiging' als knop bij 'Offerte aanvragen', zonder icoon */
    var cta=loc.querySelector('.dga-loc__cta'),off=brand&&brand.querySelector('.footer-block__cta');
    if(cta&&off){
      [].slice.call(cta.querySelectorAll('svg')).forEach(function(s){s.parentNode.removeChild(s);});
      cta.textContent=isDe?'Besichtigung planen':'Plan bezichtiging';
      cta.classList.add('pg-fcta-sec');
      var row=document.createElement('div');row.className='pg-fcta';
      off.parentNode.insertBefore(row,off);row.appendChild(off);row.appendChild(cta);
    }
    /* Vlaggetjes vullen het ronde bolletje */
    [].forEach.call(loc.querySelectorAll('.dga-loc__flag svg'),function(s){s.setAttribute('preserveAspectRatio','xMidYMid slice');});
    [].forEach.call(loc.querySelectorAll('.dga-loc__card'),function(card){
      /* Adres als link naar de routeplanner, met het locatie-icoon ervoor; de losse knop 'Route plannen' vervalt */
      var btn=card.querySelector('.dga-loc__btn'),addr=card.querySelector('.dga-loc__addr');
      if(btn&&addr&&!addr.querySelector('.pg-loc-route')){
        var a=document.createElement('a');a.className='pg-loc-route';a.href=btn.href;a.target=btn.getAttribute('target')||'_blank';a.rel='noopener noreferrer';
        var label=(btn.textContent||'Route plannen').replace(/\s+/g,' ').trim();
        a.setAttribute('aria-label',label+': '+(addr.textContent||'').replace(/\s+/g,' ').trim());
        var ico=btn.querySelector('svg');if(ico){ico=ico.cloneNode(true);ico.setAttribute('class','pg-loc-route__ico');ico.setAttribute('aria-hidden','true');a.appendChild(ico);}
        var txt=document.createElement('span');txt.className='pg-loc-route__txt';
        var nodes=[].slice.call(addr.childNodes),start=0;
        while(start<nodes.length&&(nodes[start].nodeName==='STRONG'||nodes[start].nodeName==='BR'||(nodes[start].nodeType===3&&!nodes[start].textContent.trim())))start++;
        if(start>=nodes.length)start=0;
        nodes.slice(start).forEach(function(nd){txt.appendChild(nd);});
        a.appendChild(txt);addr.appendChild(a);
        btn.parentNode.removeChild(btn);
      }
      /* Label 'Showroom' wordt een link naar de bezichtigingspagina van die showroom */
      var country=((card.querySelector('.dga-loc__country')||{}).textContent||'').trim();
      var de=/duitsland|deutschland|germany/i.test(country);
      var href=isDe?SHOWROOM_PATH_DE:SHOWROOM_PATH; /* zelfde boekingspagina voor beide vestigingen (21-10-2026) */
      /* Anker op blok-id zet de keuzeknop goed; de volgorde (nummer) verschilt per markt */
      href+=de?'#showroom-heusenstamm':'#showroom-wijchen';
      /* NL-footer: 'Showroom' bij Duitsland blijft een gewoon label, zonder link en zonder hover (21-10-2026) */
      if(!isDe&&de)return;
      [].forEach.call(card.querySelectorAll('.dga-loc__tag:not(.dga-loc__tag--hq)'),function(tag){
        if(tag.tagName==='A'||!/showroom/i.test(tag.textContent||''))return;
        var link=document.createElement('a');
        link.className=tag.className+' pg-loc-sr';link.href=href;link.textContent=(tag.textContent||'').trim();
        link.setAttribute('aria-label',(isDe?'Besichtigung planen: ':'Plan een bezichtiging: ')+'Showroom '+country);
        tag.parentNode.replaceChild(link,tag);
      });
    });
    /* Duitse footer: de Duitse showroom bovenaan */
    if(isDe){
      var wrap=loc.querySelector('.dga-loc__cards');
      var deCard=[].filter.call(loc.querySelectorAll('.dga-loc__card'),function(c){return /deutschland|duitsland|germany/i.test(((c.querySelector('.dga-loc__country')||{}).textContent||''));})[0];
      if(wrap&&deCard&&deCard.parentNode===wrap&&wrap.firstElementChild!==deCard)wrap.insertBefore(deCard,wrap.firstElementChild);
    }
  }
  function run(){
    var root=document.querySelector('.shopify-section-group-footer-group');if(!root)return;
    [].forEach.call(root.querySelectorAll('details'),function(d){
      var s=d.querySelector('summary');if(!s)return;
      var head=(s.textContent||'').trim().split('\n')[0].trim();
      if(CFG[head])build(d,CFG[head]);
      shortHead(d,head);
    });
    locations(root);
    /* Mobiel: alle menukolommen starten dicht, net als Aanbod en Automaat plaatsen (19-10-2026) */
    /* Het thema (details-accordion.js) opent op mobiel het eerste menu bij DOMContentLoaded; daarna weer dichtzetten */
    function closeMobile(){
      if(!window.matchMedia('(max-width: 749px)').matches)return;
      [].forEach.call(root.querySelectorAll('details.footer-block--menu[open]'),function(d){d.removeAttribute('open');d.style.height='';});
    }
    closeMobile();setTimeout(closeMobile,0);window.addEventListener('load',function(){setTimeout(closeMobile,0);});
    /* Opnieuw meten zodra de lettertypes geladen zijn en bij een andere schermbreedte */
    function realign(){wraps.forEach(alignHeads);}
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(realign);
    var rt=null;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(realign,150);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
